import { render } from "./SendingEmail.vue?vue&type=template&id=0a250a53&scoped=true"
import script from "./SendingEmail.vue?vue&type=script&lang=js"
export * from "./SendingEmail.vue?vue&type=script&lang=js"

import "./SendingEmail.vue?vue&type=style&index=0&id=0a250a53&lang=css"
import "./SendingEmail.vue?vue&type=style&index=1&id=0a250a53&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a250a53"]])

export default __exports__